import createEnum from 'scripts/lib/create_enum';

export default createEnum('AGENT_DECLINED', 'AGENT_TIMEOUT', 'CALLER_ABANDONED', 'CALL_ERROR');

export const UnofferedCallMessages = Object.freeze({
  CALLER_ABANDONED: 'Sorry, customer hung up',
  CALL_ERROR: 'The call was ended because of an error',
});
